export default "__VITE_ASSET__C61EsKzf__"